export const getCouncilByLga = (councils = [], councilLga) => {
  return councils.find(council => council.lga === councilLga || (council.lgas && !!~council.lgas.indexOf(councilLga)));
};

export default getCouncilByLga;